import { cEl } from '../../../util';
import lgCloiGuidebot from '../../../assets/images/learn/lg-cloi-guidebot.png';
import hyulimTemi from '../../../assets/images/learn/hyulim-temi.png';

function Guide() {
    const article = cEl('article');
    article.classList.add('delivery', 'learn-section');

    const contents = cEl('div');
    contents.innerHTML = `
    <div class="learn-header">
        <h2>병원 서비스 로봇의 종류 2 : <span class="color-brand">안내 로봇</span></h2>
    </div>
    <div class="learn-page">
        <div class="gray-box">
            <h2>안내 로봇</h2>
            <div class="img-container">
                <div class="img-wrapper border-radius">
                    <img src="${lgCloiGuidebot}" alt="LG전자 CLOi GuideBot">
                    <span>LG전자 CLOi GuideBot</span>
                </div>
                <div class="img-wrapper border-radius">
                    <img src="${hyulimTemi}" alt="휴림 안내로봇 temi">
                    <span>휴림 안내로봇 temi</span>
                </div>
            </div>
            <div class="description-container">
                <div class="description-wrapper" style="flex: 0 0 250px">
                    <div class="description-topic">사용처</div>
                    <ul class="description-list">
                        <li>복잡한 병원 구조 동행 안내</li>
                    </ul>
                </div>
                <div class="description-wrapper" style="flex: 0 0 250px">
                </div>
                <div class="description-wrapper" style="flex: 0 0 240px">
                    <div class="description-topic">장점</div>
                    <ul class="description-list">
                        <li>화면, 음성 안내 가능</li>
                    </ul>
                </div>
                <div class="description-wrapper" style="flex: 0 0 260px">
                    <div class="description-topic">주의점</div>
                    <ul class="description-list">
                        <li>환자 맞춤 주행속도 변화 필요</li>
                        <li>엘리베이터 사용 및 에러상황 대처 방안 필요</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    `;

    const buttonWrapper = cEl('div');
    buttonWrapper.classList.add('button-wrapper');

    const moreButton = cEl('button');
    moreButton.classList.add('button', 'border-button');
    moreButton.innerHTML = '다양한 안내 로봇 둘러보기';
    moreButton.addEventListener('click', e => {
        window.open('https://www.myrobotsolution.com/store/service?categoryId=23', '_blank');
    });
    buttonWrapper.appendChild(moreButton);

    contents.append(buttonWrapper);

    article.appendChild(contents);

    return article;
}

export default Guide;
